import { ValueOf } from "@evc/web-components";

export const VERSION = "2026.11.0-b283130-STG";

export const DEFAULT_BRIAN_ZOOM_FACTOR = 0.9;

export const VISUAL_IQ_MODEL_NAME = "Mentor Visual IQ";
export const WAYGATE_XML_COMMENT_TAG_VALUE = "0013:4011";
export const WAYGATE_XML_COMMENT_TAG_NAME = "DICOM_ATTRIBUTE";
export const TAGS_MAX_COUNT = 50;
export const TAGS_FLAG_VALUE = "FLAG";
export const MVIQ_FLAG_SUFFIX = "-FLAG";

export namespace BROWSER_TYPE {
  export const SAFARI = "safari";
  export const CHROME = "chrome";
  export const IE = "ie";
  export const EDGE = "edge";
  export const FIREFOX = "firefox";
  export const OPERA = "opera";
  export const OTHER = "other";
}

export namespace DEVICE_TYPE {
  export const IPAD = "iPad";
  export const IPHONE = "iPhone";
  export const ANDROID = "Android";
  export const OTHER = "other";
}

export const INSPECTION_STATUS = new Map<string, string>([
  ["000", "Not started"],
  ["500", "Editing"],
  ["900", "Completed"]
]);

export namespace INSPECTION_STATUS_CODE {
  export const NOTINSPECTED = "000";
  export const EDITING = "500";
  export const COMPLETED = "900";
}

export namespace INSPECTION_IMAGE_STATUS_CODE {
  export const UPLOADING = "500";
  export const COMPLETED = "900";
  export const ERROR = "Error";
}

export const INSPECTION_REPORT_STATUS = new Map<string, string>([
  ["000", "Editing"],
  ["400", "Editing"],
  ["500", "Editing"],
  ["600", "Editing"],
  ["900", "Completed"]
]);
export namespace INSPECTION_REPORT_STATUS_CODE {
  export const EDITING = "000";
  export const FAILED = "400";
  export const DRAFT_PROCESSING = "500";
  export const FINAL_PROCESSING = "600";
  export const COMPLETED = "900";
}

export const SORT_TYPE = new Map<string, string[]>([
  ["Datetime(Ascending order)", ["Datetime", "asc"]],
  ["Datetime(Descending order)", ["Datetime", "desc"]],
  ["Location(Ascending order)", ["Location", "asc"]],
  ["Location(Descending order)", ["Location", "desc"]],
  ["Filename(Ascending order)", ["Filename", "asc"]],
  ["Filename(Descending order)", ["Filename", "desc"]],
  ["Mark(Ascending order)", ["Mark", "asc"]],
  ["Mark(Descending order)", ["Mark", "desc"]],
  ["Title(Ascending order)", ["Title", "asc"]],
  ["Title(Descending order)", ["Title", "desc"]]
]);

export namespace IMAGE_TYPE {
  export const INSPECTIONIMAGE = "InspectionImage";
  export const DATAPLATE = "DataPlate";
}

export namespace DEFAULT_SORT_SETTING {
  export const SORT = "SortOrder";
  export const SORTORDER = "asc";
}

export namespace PDF_COMPRESS_PARAMS_LOW {
  export const DPI = 50;
  export const QUALITY = 75;
  export const KEY = 2;
}

export namespace PDF_COMPRESS_PARAMS_MEDIUM {
  export const DPI = 150;
  export const QUALITY = 75;
  export const KEY = 1;
}

export namespace PDF_COMPRESS_PARAMS_HIGH {
  export const DPI = 200;
  export const QUALITY = 75;
  export const KEY = 0;
}

export namespace PaperKind {
  export const Default = "Letter";
  export const A0 = "A0";
  export const A1 = "A1";
  export const A2 = "A2";
  export const A3 = "A3";
  export const A4 = "A4";
  export const A5 = "A5";
  export const A6 = "A6";
  export const A7 = "A7";
  export const A8 = "A8";
  export const A9 = "A9";
  export const B0 = "B0";
  export const B1 = "B1";
  export const B2 = "B2";
  export const B3 = "B3";
  export const B4 = "B4";
  export const B5 = "B5";
  export const B6 = "B6";
  export const B7 = "B7";
  export const B8 = "B8";
  export const B9 = "B9";
  export const B10 = "B10";
  export const Ledger = "Ledger";
  export const Legal = "Legal";
  export const Letter = "Letter";
  export const Tabloid = "Tabloid";
  export const B5JIS = "B5JIS";
}

export class PrintScreenType {
  value: string;
  viewValue: string;
}

export const PRINTSCREEN_ITEMS: PrintScreenType[] = [
  { value: "All", viewValue: "All" },
  { value: "PrintScreen", viewValue: "PrintScreen" },
  { value: "Original", viewValue: "Original" }
];

export namespace REGULAR_EXPRESSION {
  // 予約語〝坊角英数字〝漢字〝記坷〝㝝㝮他記坷㝯使用場所㝧正覝表睾形弝㝮文字列㝫戝型㝗〝インスタンスを生戝㝗使用㝙る必覝㝌㝂る
  // 予約語
  export const RESERVED_WORDS_PATTERN =
    "(?!( *A *U *X *$| *C *O *N *$| *C *O *M *[0-9] *$| *L *P *T *[0-9] *$| *N *U *L *$| *P *R *N *$| *C *L *O *C *K *\\$ *$))";
  // 坊角英数字
  export const HALF_ALPHANUMERIC_PATTERN = "a-zA-Z0-9";
  // 漢字
  export const KANJI_PATTERN = "\\u4E00-\\u9FFF";
  // 記坷
  export const SYMBOL_PATTERN = "!#$%&'()+\\-;=@\\[\\]^`{}~_,. ";
  // 㝝㝮他記坷
  export const OTHER_SYMBOL_PATTERN = '/":*';

  // メールアドレス形弝
  export const EMAIL_PATTERN: RegExp =
    /^[a-zA-Z0-9!#$%&'_`/=~*+-?^{|}]+(\.[a-zA-Z0-9!#$%&'_`/=~*+-?^{|}]+)*@[a-zA-Z0-9][a-zA-Z0-9-]*(\.[a-zA-Z0-9-]+)+$/;
  // 電話番坷形弝
  export const NUMBER_PATTERN: RegExp = /^(0|[1-9]\d*)$/;
  // 10進数
  export const DECIMAL_PATTERN: RegExp = /^(0|[1-9]\d*)(\.\d+)?$/;
  // 先頭尝文字
  export const SMALL_LETTERS_PATTERN: RegExp = /[a-z0-9]/;
  // 画僝坝
  export const IMAGE_FILENAME_PATTERN: RegExp = /[.*+?^=!:${}()|[\]\/\\]/g;
  // 空白文字
  export const SPACE_PATTERN: RegExp = /[\s ]+/i;
  export const DOT_PATTERN: RegExp = /[.]/;
}

// AI-UI
export namespace DAMAGE_TYPE {
  export const CHIP = "chip";
  export const CRACK = "crack";
  export const SCRATCH = "scratch";
}
// AI-UI
export namespace DAMAGE_TYPE_COLOR {
  export const CHIP = "#41F291";
  export const CRACK = "#FDEA56";
  export const SCRATCH = "#FA52AB";
}

export namespace EVAL_TYPE {
  export const DETECTION_ALL = "detection-all";
}

export namespace PERMISSION_CODE {
  export const READ = 1;
  export const WRITE = 2;
}

export namespace DATE_PICKER_VALIDATION {
  export const MIN_YEAR = 1753;
  export const MIN_DAY = 1;
  export const MIN_MONTH = 1;
  export const MAX_YEAR = 3000;
  export const MAX_DAY = 31;
  export const MAX_MONTH = 12;
}
export class MARKCOLORITEMS {
  name: string;
  color: string;
}

export const MARK_DISABLED_COLOR = "#fffffe00";

export const MARK_COLOR_ITEMS: MARKCOLORITEMS[] = [
  { name: "White", color: "#ffffff" },
  { name: "silver", color: "#c0c0c0" },
  { name: "Gray", color: "#808080" },
  { name: "DimGray", color: "#696969" },
  { name: "Red", color: "#ff0000" },
  { name: "OrangeRed", color: "#ff4500" },
  { name: "tomato", color: "#ff6347" },
  { name: "Coral", color: "#ff7f50" },
  { name: "Salmon", color: "#fa8072" },
  { name: "RosyBrown", color: "#bc8f8f" },
  { name: "IndianRed", color: "#cd5c5c" },
  { name: "Maroon", color: "#800000" },
  { name: "SandBrown", color: "#8b4513" },
  { name: "Chocolate", color: "#d2691e" },
  { name: "DarkGoldenrod", color: "#b8860b" },
  { name: "Pure", color: "#cd853f" },
  { name: "SandyBrown", color: "#f4a460" },
  { name: "Orange", color: "#ffa500" },
  { name: "Gold", color: "#ffd700" },
  { name: "Yellow", color: "#ffff00" },
  { name: "Khaki", color: "#f0e68c" },
  { name: "Tan", color: "#d2b48c" },
  { name: "Olive", color: "#808000" },
  { name: "OliveRad", color: "#6b8e23" },
  { name: "DarkOliveGreen", color: "#556b2f" },
  { name: "YellowGreen", color: "#9acd32" },
  { name: "LimeGreen", color: "#32cd32" },
  { name: "Lime", color: "#00ff00" },
  { name: "GreenYellow", color: "#adff2f" },
  { name: "MediumSpringGreen", color: "#00fa9a" },
  { name: "LightGreen", color: "#90ee90" },
  { name: "SeaGreen", color: "#2e8b57" },
  { name: "Green", color: "#008000" },
  { name: "DarkSlateGray", color: "#2f4f4f" },
  { name: "DarkCyan", color: "#008b8b" },
  { name: "LightSeaGreen", color: "#20b2aa" },
  { name: "Cyan", color: "#00ffff" },
  { name: "PaleTurquoise", color: "#afeeee" },
  { name: "SkyBlue", color: "#87ceeb" },
  { name: "DeepSkyBlue", color: "#00bfff" },
  { name: "CornFlowerBlue", color: "#6495ed" },
  { name: "Blue", color: "#0000ff" },
  { name: "Navy", color: "#000080" },
  { name: "RoyalBlue", color: "#4169e1" },
  { name: "LightSteelBlue", color: "#b0c4de" },
  { name: "SlateBlue", color: "#6a5acd" },
  { name: "MediumPurple", color: "#9370db" },
  { name: "BlueViolet", color: "#8a2be2" },
  { name: "DarkSlateBlue", color: "#483d8b" },
  { name: "Indigo", color: "#4b0082" },
  { name: "Purple", color: "#800080" },
  { name: "DarkViolet", color: "#9400d3" },
  { name: "Violet", color: "#ee82ee" },
  { name: "Magenta", color: "#ff00ff" },
  { name: "Pink", color: "#ffc0cb" },
  { name: "PaleVioletRed", color: "#db7093" },
  { name: "HotPink", color: "#ff69b4" },
  { name: "DeepPink", color: "#ff1493" },
  { name: "MediumVioletRed", color: "#c71585" },
  { name: "Crimson", color: "#dc143c" },
  { name: "Black", color: "#000000" },
  { name: "None", color: "#ffffff00" },
  { name: "Disabled", color: MARK_DISABLED_COLOR }
];

export const ANNOTATION_COLOR_ITEMS: MARKCOLORITEMS[] = [
  { name: "White", color: "#ffffff" },
  { name: "Gray", color: "#808080" },
  { name: "Red", color: "#ff0000" },
  { name: "Orange", color: "#ffa500" },
  { name: "Yellow", color: "#ffff00" },
  { name: "Lime", color: "#00ff00" },
  { name: "Blue", color: "#0000ff" },
  { name: "Cyan", color: "#00ffff" },
  { name: "Magenta", color: "#ff00ff" },
  { name: "DeepPink", color: "#ff1493" },
  { name: "Black", color: "#000000" }
];

export class FILETYPEITEMS {
  label: string;
  value: string;
}

export const FILE_TYPE_ITEMS: FILETYPEITEMS[] = [
  { label: "xlsx (Horizontal)", value: "xlsx1" }
  // { label: 'xlsx (Vertical)', value: 'xlsx2' },
  // { label: 'csv (Horizontal)', value: 'csv1' },
  // { label: 'csv (Vertical)', value: 'csv2' },
  // { label: 'json', value: 'json' }
];

export namespace REPORT_TITLE_INPUT_CODE {
  export const MANUAL = "0";
}
export namespace UPLOAD_RESULT_CODE {
  export const BEFOREUPLOAD = "0";
  export const SUCCESS = "1";
  export const FAILED = "2";
  export const UPLOADING = "3";
}

export namespace PAGINATION_VALUES {
  export const START_INDEX = 0;
  export const DEFAULT_PAGE_SIZE = 20;
}

export const DYNAMIC_SELECT_ITEM = [
  { label: "tenant.name", value: "tenant.name" },
  { label: "inspectionReport.title", value: "inspectionReport.title" },
  { label: "inspectionReport.revision", value: "inspectionReport.revision" },
  { label: "inspectionReport.owner", value: "inspectionReport.owner" },
  { label: "inspectionReport.subjectModel.name", value: "inspectionReport.subjectModel.name" },
  { label: "inspection.inspectionDate", value: "inspection[0].inspectionDate" },
  { label: "inspection.subject.serialNo", value: "inspection[0].subject.serialNo" },
  { label: "inspection.inspectors.name", value: "inspection[0].inspectors.name" },
  { label: "inspection.inspectors.initials", value: "inspection[0].inspectors.initials" },
  { label: "inspection.inspectors.email", value: "inspection[0].inspectors.email" },
  { label: "inspection.inspectors.telephoneNumber", value: "inspection[0].inspectors.telephoneNumber" },
  { label: "system.now", value: "system.now" },
  { label: "dataPlate.location.name", value: "dataPlate.location.name" },
  { label: "pageNumber", value: "pageNumber" }
];

export namespace MODEL_CODE {
  export const IPLEXNX = "IPLEXNX";
}

export namespace OSC_FILE_TYPE {
  export const IPLEXIMG = "IPLEXIMG";
  export const IPLEXTIFFIMG = "IPLEXTIFFIMG";
}

export namespace CONFIG_HEADER_LABEL {
  export const FEATURE = "Enable advanced feature";
  export const BEHAVIOR = "Switch application behavior";
  export const ATTRIBUTE = "Additional attributes";
  export const TERMINOLOGY = "Define terminology";
}

export namespace TenantConfig {
  export namespace IsEnabledAnalytics {
    export const KEY = "IsEnabledAnalytics";
  }

  export namespace ImageSelectModeWhenCreatingReport {
    export const KEY = "ImageSelectModeWhenCreatingReport";
    export const FALSE = 0;
    export const TRUE = 1;
    export const OPTIONAL = 2;
  }

  export namespace IsSelectedAllFolderWhenCreatingReport {
    export const KEY = "IsSelectedAllFolderWhenCreatingReport";
  }

  export namespace ShowTagsOnImages {
    export const KEY = "ShowTagsOnImages";
  }

  /** Layout of the location folders when an inspection structure or an inspection is exported (desktop and cloud) */
  export namespace InspectionStructureFormat {
    export const KEY = "InspectionStructureFormat";
    export const LEGACY = 0;
    export const TREE = 1;
  }

  export namespace DefaultMarkWhenUploadingNoMarkImage {
    export const KEY = "DefaultMarkWhenUploadingNoMarkImage";
    export const X = 0;
    export const A = 1;
    export const B = 2;
    export const C = 3;
    export const D = 4;
    export const E = 5;
    export const F = 6;
    export const G = 7;
  }

  export namespace DefaultMarkWhenNoCorrespondingMark {
    export const DefaultMarkIdentifier = 0;
  }

  export namespace DefaultUnitOfMeasurementResult {
    export const KEY = "DefaultUnitOfMeasurementResult";
  }

  export namespace DefaultImageQualityOfFinalReports {
    export const KEY = "DefaultImageQualityOfFinalReports";
  }

  export namespace DefaultImageQualityOfDraftReports {
    export const KEY = "DefaultImageQualityOfDraftReports";
  }

  export namespace SubjectAttributeOwner {
    export const KEY = "SubjectAttributeOwner";
  }

  export namespace SubjectAttributeCountry {
    export const KEY = "SubjectAttributeCountry";
  }

  export namespace SubjectAttributeState {
    export const KEY = "SubjectAttributeState";
  }

  export namespace SubjectAttributeDistrict {
    export const KEY = "SubjectAttributeDistrict";
  }

  export namespace SubjectAttributeSite {
    export const KEY = "SubjectAttributeSite";
  }

  export namespace SubjectAttributeProject {
    export const KEY = "SubjectAttributeProject";
  }

  // SubjectAttribute Values
  export const HIDE = 0;
  export const DISPLAY_AND_REQUIRED = 1;
  export const DISPLAY_AND_OPTIONAL = 2;

  export namespace LabelOfMark {
    export const KEY = "LabelOfMark";
  }

  export namespace LabelOfTitle {
    export const KEY = "LabelOfTitle";
  }

  export namespace LabelOfTags {
    export const KEY = "LabelOfTags";
  }

  export namespace LabelOfIplexOne {
    export const KEY = "LabelOfIplexOne";
  }

  export namespace LabelOfOwner {
    export const KEY = "LabelOfOwner";
  }

  export namespace LabelOfCountry {
    export const KEY = "LabelOfCountry";
  }

  export namespace LabelOfState {
    export const KEY = "LabelOfState";
  }

  export namespace LabelOfRegion {
    export const KEY = "LabelOfRegion";
  }

  export namespace LabelOfSite {
    export const KEY = "LabelOfSite";
  }

  export namespace LabelOfProject {
    export const KEY = "LabelOfProject";
  }

  export namespace LabelOfSerialNumber {
    export const KEY = "LabelOfSerialNumber";
  }

  export const DefaultConfigurationValues = {
    [IsEnabledAnalytics.KEY]: false,
    [ImageSelectModeWhenCreatingReport.KEY]: 2,
    [IsSelectedAllFolderWhenCreatingReport.KEY]: false,
    [DefaultMarkWhenUploadingNoMarkImage.KEY]: 0,
    [DefaultUnitOfMeasurementResult.KEY]: 0,
    [InspectionStructureFormat.KEY]: InspectionStructureFormat.LEGACY,
    [SubjectAttributeOwner.KEY]: "FALSE",
    [SubjectAttributeCountry.KEY]: "FALSE",
    [SubjectAttributeState.KEY]: "FALSE",
    [SubjectAttributeDistrict.KEY]: "FALSE",
    [SubjectAttributeSite.KEY]: "FALSE",
    [SubjectAttributeProject.KEY]: "FALSE",
    [LabelOfMark.KEY]: "Mark",
    [LabelOfTitle.KEY]: "Title",
    [LabelOfOwner.KEY]: "Owner",
    [LabelOfCountry.KEY]: "Country",
    [LabelOfState.KEY]: "State",
    [LabelOfRegion.KEY]: "Region",
    [LabelOfSite.KEY]: "Site",
    [LabelOfProject.KEY]: "Project",
    [LabelOfSerialNumber.KEY]: "S/N",
    [LabelOfTags.KEY]: "Tags"
  };
}

export namespace UserConfig {
  export namespace IsEnabledDarkMode {
    export const KEY = "IsEnabledDarkMode";
  }

  export namespace CurrentLanguage {
    export const KEY = "CurrentLanguage";
  }
}

export namespace TENANT_ROLE {
  export const OWNER = "Owner";
  export const ADMIN = "Admin";
  export const USER = "User";
  export const GUEST = "Guest";
}

export namespace FILTER_CONTENT_ID {
  export const STATUS = "status";
  export const SUBJECT_MODEL = "subjectModel";
  export const SUBJECT = "subject";
  export const IS_OWN = "isOwn";
  export const SELECTED_ONLY = "selectedOnly";
  export const OWNER = "owner";
  export const COUNTRY = "Country";
  export const STATE = "State";
  export const DISTRICT = "District";
  export const SITE = "Site";
  export const PROJECT = "Project";
}

export namespace PLATFORM {
  export const WEB = "web";
  export const DESKTOP = "desktop";
}

export namespace ENVIRONMENT {
  export const LOCAL = "Local";
  export const DEVELOPMENT = "Development";
  export const STAGING = "Staging";
  export const PRODUCTION = "Production";
}

export namespace MODE {
  export const VISOL = "visol";
  export const BRIAN = "brian";
}

export namespace GUID {
  export const generateUUID = () => {
    const chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  };
}

export enum USE_IMAGE_TYPE {
  ORIGINAL = 0,
  RETOUCHED = 1,
  REMEASUREMENT = 2,
  ORIGINAL_THUMBNAIL = 3,
  RETOUCHED_THUMBNAIL = 4,
  REMEASUREMENT_THUMBNAIL = 5
}

export namespace DOCUMENT_FILETYPE {
  export const PDF = "application/pdf";

  export const EXTENSION_PDF = "pdf";
  export const EXTENSION_XLSX = "xlsx";
}

export namespace COMPRESSED_FILETYPE {
  export const ZIP = "application/zip";

  export const EXTENSION_ZIP = "zip";
}

export namespace IMAGE_FILETYPE {
  export const JPG = "image/jpg";
  export const JPEG = "image/jpeg";
  export const PNG = "image/png";
  export const BMP = "image/bmp";
  export const TIF = "image/tif";
  export const TIFF = "image/tiff";
  export const HEIC = "image/heic";
  export const HEIF = "image/heif";
  export const MP4 = "video/mp4";
  export const MP4_APPLICATION = "application/mp4";
  export const JSON = "application/json";
  export const WAV = "audio/wav";
  export const BINARY = "application/octet-stream";
  export const AVI = "video/avi";
  export const AVI_MSVIDEO = "video/msvideo";
  export const AVI_XMSVIDEO = "video/x-msvideo";

  export const EXTENSION_JPG = "jpg";
  export const EXTENSION_JPEG = "jpeg";
  export const EXTENSION_JFIF = "jfif";
  export const EXTENSION_TIF = "tif";
  export const EXTENSION_TIFF = "tiff";
  export const EXTENSION_HEIC = "heic";
  export const EXTENSION_HEIF = "heif";
  export const EXTENSION_PNG = "png";
  export const EXTENSION_BMP = "bmp";
  export const EXTENSION_MP4 = "mp4";
  export const EXTENSION_JSON = "json";
  export const EXTENSION_JSN = "jsn";
  export const EXTENSION_WAV = "wav";
  export const EXTENSION_AVI = "avi";
  export const EXTENSION_XMSVIDEO = "x-msvideo";
  export const EXTENSION_MSVIDEO = "msvideo";
}

export const IMAGE_FILETYPE_MAP: { [extension: string]: string } = {
  [IMAGE_FILETYPE.EXTENSION_JPG]: IMAGE_FILETYPE.JPEG, // this is not an error, it is needed for the current validation in the BE.
  [IMAGE_FILETYPE.EXTENSION_JPEG]: IMAGE_FILETYPE.JPEG,
  [IMAGE_FILETYPE.EXTENSION_JFIF]: IMAGE_FILETYPE.JPEG,
  [IMAGE_FILETYPE.EXTENSION_TIF]: IMAGE_FILETYPE.TIF,
  [IMAGE_FILETYPE.EXTENSION_TIFF]: IMAGE_FILETYPE.TIFF,
  [IMAGE_FILETYPE.EXTENSION_HEIC]: IMAGE_FILETYPE.HEIC,
  [IMAGE_FILETYPE.EXTENSION_HEIF]: IMAGE_FILETYPE.HEIF,
  [IMAGE_FILETYPE.EXTENSION_PNG]: IMAGE_FILETYPE.PNG,
  [IMAGE_FILETYPE.EXTENSION_BMP]: IMAGE_FILETYPE.BMP,
  [IMAGE_FILETYPE.EXTENSION_MP4]: IMAGE_FILETYPE.MP4,
  [IMAGE_FILETYPE.EXTENSION_AVI]: IMAGE_FILETYPE.AVI,
  [IMAGE_FILETYPE.EXTENSION_JSON]: IMAGE_FILETYPE.JSON,
  [IMAGE_FILETYPE.EXTENSION_JSN]: IMAGE_FILETYPE.EXTENSION_JSN,
  [IMAGE_FILETYPE.EXTENSION_WAV]: IMAGE_FILETYPE.WAV
};

export namespace METADATA_FILETYPE {
  export const EXTENSION_XML = "text/xml";
}

export namespace MEASUREMENT_IMAGE_TYPE {
  export const IV7_IMAGE = "iv7";
  export const VEGA_IMAGE = "vega";
  export const SOLEIL_IMAGE = "soleil";
  export const BRIAN_IMAGE = "brian";
  export const THESEUS_IMAGE = "theseus";
  export const VIDEO_IMAGE = "video";
  export const NONE_IMAGE = "none";
  export const ANYIMAGE_IMAGE = "anyimage";
}

export namespace SCOPE_MODEL {
  /** Videoscope model stored in the image EXIF for IPLEX One (Brian) devices. */
  export const IPLEX_ONE = "IPX One";
  /** Videoscope model stored in the image EXIF by Merry, which keeps its capture data in XMP instead. */
  export const MERRY = "IPLEX ONE";
}

export namespace MEASUREMENT_IMAGE_MODE {
  export const IV7 = "IV7";
  export const NX = "NX";
  export const ThreeD = "3D";
}

export namespace MEASUREMENT_MODE {
  export const DISTANCE = "distance";
  export const POINT_TO_LINE = "pointToLine";
  export const DEPTH = "depth";
  export const LINES = "lines";
  export const AREA = "area";
  export const MISSING_CORNER = "missingCorner";
  /** Stored by the Merry tab for its missing corner (media viewer TipDefect) measurements. */
  export const TIP_DEFECT = "tipDefect";
}

export namespace ExifOrientation {
  export const Default = 1;
  export const MirrorHorizontal = 2;
  export const Rotate180 = 3;
  export const MirrorVertical = 4;
  export const MirrorHorizontalAndRotate270 = 5;
  export const Rotate90 = 6;
  export const MirrorHorizontalAndRotate90 = 7;
  export const Rotate270 = 8;
}

export enum GEN_DRAFT_REPORT_TYPE {
  DEFAULT = 0,
  SHARE_IMAGES = 1,
  CANCEL = 2
}

export enum GEN_FINAL_REPORT_TYPE {
  CREATE = 0,
  GET = 1,
  CANCEL = 2
}

export const LANGUAGE = {
  ENGLISH: "en",
  ARABIC: "ar-SA",
  CZECH: "cs-CZ",
  GERMAN: "de-DE",
  SPANISH: "es-ES",
  FRENCH: "fr-FR",
  HUNGARIAN: "hu-HU",
  ITALIAN: "it-IT",
  JAPANESE: "ja-JP",
  KOREAN: "ko-KR",
  POLISH: "pl-PL",
  PORTUGUESE: "pt-PT",
  RUSSIAN: "ru-RU",
  THAI: "th-TH",
  CHINESE_SIMPLIFIED: "zh-CN",
  CHINESE_TRADITIONAL: "zh-TW",
  TURKISH: "tr-TR"
};

export const SUPPORTED_LANGUAGES = [
  { code: LANGUAGE.ENGLISH, label: "English" },
  { code: LANGUAGE.ARABIC, label: "العربية" },
  { code: LANGUAGE.CZECH, label: "Čeština" },
  { code: LANGUAGE.GERMAN, label: "Deutsch" },
  { code: LANGUAGE.SPANISH, label: "Español" },
  { code: LANGUAGE.FRENCH, label: "Français" },
  { code: LANGUAGE.HUNGARIAN, label: "Magyar" },
  { code: LANGUAGE.ITALIAN, label: "Italiano" },
  { code: LANGUAGE.JAPANESE, label: "日本語" },
  { code: LANGUAGE.KOREAN, label: "한국어" },
  { code: LANGUAGE.POLISH, label: "Polski" },
  { code: LANGUAGE.PORTUGUESE, label: "Português" },
  { code: LANGUAGE.RUSSIAN, label: "Русский" },
  { code: LANGUAGE.THAI, label: "ไทย" },
  { code: LANGUAGE.TURKISH, label: "Türkçe" },
  { code: LANGUAGE.CHINESE_SIMPLIFIED, label: "简体中文" },
  { code: LANGUAGE.CHINESE_TRADITIONAL, label: "繁體中文" }
];

export const multiSelectEditableTextsSeparator: string = "$separator$";

export namespace SCREEN_SIZE_BREAKPOINT {
  export const COMPACT_MAX = 599;
  export const MEDIUM_MIN = 600;
  export const MEDIUM_MAX = 839;
  export const EXPANDED_MIN = 840;
  export const EXPANDED_MAX = 1199;
  export const LARGE_MIN = 1200;
  export const LARGE_MAX = 1599;
  export const EXTRA_LARGE_MIN = 1600;
}

export namespace SCREEN_SIZE {
  export const COMPACT = "compact";
  export const MEDIUM = "medium";
  export const EXPANDED = "expanded";
  export const LARGE = "large";
  export const EXTRA_LARGE = "extra-large";
}

export namespace LOCAL_STORAGE {
  export const VISOL_PLATFORM = "visol_platform";
  export const LANGUAGE_PREFERENCE = "language_preference";
}

export const DEFAULT_30_DAY_EXPIRATION = 30;

export namespace FEATURE_FLAGS {
  export const GE_CONNECTOR = "ge_connector";
  export const ASSET_MODULE = "asset_module";
  export const INSPECTION_ROOT_ONLY_ASSETS = "inspection_root_only_assets";
}

export type FEATURE_FLAGS = ValueOf<typeof FEATURE_FLAGS>;
